/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const AppleFilesIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Apple Files',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M31.66 8H17.709a2.347 2.347 0 0 1-1.3-.393L11.59 4.393A2.343 2.343 0 0 0 10.292 4H4.34A2.34 2.34 0 0 0 2 6.34v21.32A2.34 2.34 0 0 0 4.34 30h27.32A2.34 2.34 0 0 0 34 27.66V10.34A2.34 2.34 0 0 0 31.66 8ZM4 11.5A1.5 1.5 0 0 1 5.5 10h25a1.5 1.5 0 0 1 1.5 1.5v.5H4Z"
    />
  </svg>`;
};
